import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-338209d1"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "wanfazhuangtai"
};
const _hoisted_2 = {
  class: "panel"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "panel-title"
}, [/*#__PURE__*/_createElementVNode("h2", null, "玩法状态")], -1));

const _hoisted_4 = {
  class: "panel-body"
};
const _hoisted_5 = {
  class: "game-select"
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode("分类：");

const _hoisted_7 = {
  style: {
    "margin": "10px 0"
  }
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode("彩票：");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("开");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("关");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_link = _resolveComponent("el-link");

  const _component_el_radio_button = _resolveComponent("el-radio-button");

  const _component_el_radio_group = _resolveComponent("el-radio-group");

  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_radio = _resolveComponent("el-radio");

  const _component_el_table = _resolveComponent("el-table");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [_createVNode(_component_el_link, {
    underline: false
  }, {
    default: _withCtx(() => [_hoisted_6]),
    _: 1
  }), _createVNode(_component_el_radio_group, {
    modelValue: $data.pid,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.pid = $event),
    size: "small",
    onChange: $options.change_group
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.game_group, item => {
      return _openBlock(), _createBlock(_component_el_radio_button, {
        key: item.name,
        label: item.pid
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
        _: 2
      }, 1032, ["label"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_link, {
    underline: false
  }, {
    default: _withCtx(() => [_hoisted_8]),
    _: 1
  }), _createVNode(_component_el_radio_group, {
    modelValue: $data.gid,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.gid = $event),
    size: "small",
    onChange: $options.change_game
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.game_list, item => {
      return _openBlock(), _createBlock(_component_el_radio_button, {
        key: item.id,
        label: item.id
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.gname), 1)]),
        _: 2
      }, 1032, ["label"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])])]), _createVNode(_component_el_table, {
    data: $data.list,
    border: "",
    size: "small",
    "highlight-current-row": "",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row",
    "table-layout": "auto"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "name",
      label: "玩法",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "status",
      label: "开通状态",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_radio_group, {
        modelValue: scope.row.status,
        "onUpdate:modelValue": $event => scope.row.status = $event,
        onChange: $event => $options.change_status(scope.row, $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          size: "small",
          label: 1
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        }), _createVNode(_component_el_radio, {
          size: "small",
          label: 0
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        })]),
        _: 2
      }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["data"])])])]);
}